import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgDiscord = function SvgDiscord(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#5865F2",
        d: "M60.137 0h-.274C26.802 0 0 26.802 0 59.863v.274C0 93.198 26.802 120 59.863 120h.274C93.198 120 120 93.198 120 60.137v-.274C120 26.802 93.198 0 60.137 0"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M90.028 32.452a71.4 71.4 0 0 0-17.636-5.47.26.26 0 0 0-.282.135c-.761 1.354-1.606 3.124-2.195 4.511-6.659-.996-13.285-.996-19.81 0-.592-1.42-1.467-3.157-2.232-4.511a.28.28 0 0 0-.282-.134 71.4 71.4 0 0 0-17.636 5.47.27.27 0 0 0-.118.1C18.603 49.336 15.526 65.707 17.035 81.876a.3.3 0 0 0 .114.202c7.412 5.445 14.592 8.75 21.639 10.94a.28.28 0 0 0 .302-.101 51 51 0 0 0 4.427-7.202.277.277 0 0 0-.151-.383 48 48 0 0 1-6.76-3.22.28.28 0 0 1-.03-.462c.454-.341.908-.694 1.341-1.052.08-.067.19-.08.282-.037 14.18 6.474 29.535 6.474 43.547 0a.26.26 0 0 1 .282.033c.433.358.887.715 1.345 1.056a.28.28 0 0 1-.025.462 44.4 44.4 0 0 1-6.765 3.22.276.276 0 0 0-.147.387 58 58 0 0 0 4.423 7.198c.067.096.19.138.303.105 7.08-2.19 14.26-5.495 21.672-10.94a.3.3 0 0 0 .114-.197c1.808-18.692-3.027-34.929-12.81-49.324a.23.23 0 0 0-.114-.105zm-44.4 39.578c-4.272 0-7.786-3.918-7.786-8.732s3.451-8.732 7.786-8.732 7.858 3.956 7.786 8.732c0 4.814-3.452 8.732-7.786 8.732m28.794 0c-4.271 0-7.786-3.918-7.786-8.732s3.452-8.732 7.786-8.732c4.335 0 7.858 3.956 7.787 8.732 0 4.814-3.414 8.732-7.787 8.732"
    })));
};

export { SvgDiscord as ReactComponent };
//# sourceMappingURL=Discord.svg.es.js.map
